import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-analytics-container',
  templateUrl: './analytics-container.component.html',
  styleUrls: ['./analytics-container.component.scss']
})
export class AnalyticsContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
